import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal } from "react-bootstrap";
import useStateRef from 'react-usestateref';
import { Link,useNavigate } from "react-router-dom";
import Card from "../../../../../components/Card";
import swal from 'sweetalert';
//import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import Select from 'react-select';
import "../../../../App.css";


const TableData = () => {

  const [DtDetTable, setDtDetTable, DtDetTableRef]=useStateRef([]);
  let DetTable=[];

  const [isDisabled, setisDisabled]=useState(false);


  const [DtStDetTable, setDtStDetTable, DtStDetTableRef]=useStateRef([]);
  let StDetTable=[];

 const [SaveButtonText, setSaveButtonText] = useState("Save");
 
 
  useEffect(() => {

    
    
    sessionStorage.getItem("OrnamentIssue_EditElg")==='true' ?  setDisabled(''):  setDisabled('disabled');
   
	
   if(sessionStorage.getItem("OrnamentIssue_Action")=="Add")
   {
	    setSaveButtonText("Save");
      document.getElementById("optGold").checked=true;
      document.getElementById("optSmith").checked=true;
     
    document.getElementById("txtIssueNo").value="{Auto}";
    document.getElementById("txtIssueDate").value=(new Date()).toISOString().substring(0,10);
   
	//Clear();
   
   }
   else if(sessionStorage.getItem("OrnamentIssue_Action")=="Edit")
   {
	   setSaveButtonText("Update");
	   Display(sessionStorage.getItem("OrnamentIssue_EditId"));
   }
   else if(sessionStorage.getItem("OrnamentIssue_Action")=="Delete")
   {
	   setSaveButtonText("Delete");
	   Display(sessionStorage.getItem("OrnamentIssue_EditId"));
   }
	
   ControlSettings();

   innitialSetValue();
   

  }, []);
  
  async function TagPrint()
  {
    try
    {
     
      let postData = {
        TagId: document.getElementById("txtIssueNo").value
    }
  
    
  
    const results = await apiService.postCall("ornamentissue/tagprint",postData);
  
  
   if (results != "-1") {
  
   }
  }
  
  catch (error) {
    console.log(error);
  }
  }
  

  
  function innitialSetValue() {


  getLookup();

  }


  const [show1, setShow1] = useState(false);
  const [sho, setSho] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
 
   const [TMshow1, setTMShow1] = useState(false);
   const TMhandleClose1 = () => setTMShow1(false);
   const TMhandleShow1 = () => setTMShow1(true);
    
   const [localtime,setlocaltime] =useState(new Date());
   const [btndisabled, setDisabled] = useState('disabled');

  const [DtParty, setDtParty]=useState([]);
  const [DtGrnNo, setDtGrnNo]=useState([]);
  

  const [AccCode, setAccCode, AccCodeRef] = useStateRef();
  const [GrnNo, setGrnNo, GrnNoRef] = useStateRef();

 function SetGridValue(id,value,Col)
 {
  let i=0;

  DetTable=DtDetTable;

 
 
  for(i=0;i<DetTable.length;i++)
  {
    if(id==DetTable[i].ID)
    {
     if (Col=='Pcs') 
      DetTable[i].Pcs=value;
     else if(Col=='GrossWt')
     DetTable[i].GrossWt=value;
     else if(Col=='LessWt')
     DetTable[i].LessWt=value;
     else if(Col=='WasteP')
     DetTable[i].WasteP=value;
     else if(Col=='Touch')
     DetTable[i].Touch=value;
    }  
}
setDtDetTable(DetTable);

setlocaltime(new Date());

Calc(id);

 }











 function gridRemove (id) {

  
      
      DetTable=DtDetTable;
       
        var cnt = 0;
        try {
            cnt = DetTable.length;
        }
        catch (err) {
            cnt = 0;
        }
     
      let i=0;

        for (i = 0; i < cnt; i++)
        {
            if (DetTable[i].ID == id)
            {
                DetTable.splice(i, 1);
                break;
            }
        }

			setDtDetTable(DetTable);
      
			
			
      //Clear();

    }




function val(value)
{
	value=parseFloat(value);
	if(isNaN(value)==true)
		value=0;
	else
		value=value;
	
	return value;
}




function Calc(id)
{
 
  
  let i=0;

  DetTable=DtDetTable;

 
 
  for(i=0;i<DetTable.length;i++)
  {
    if(id==DetTable[i].ID)
    {
      DetTable[i].NetWt=val(DetTable[i].GrossWt)-val(DetTable[i].LessWt);
      DetTable[i].Wasteage=parseFloat((val(DetTable[i].NetWt)*val(DetTable[i].WasteP)/100)).toFixed(2);
      DetTable[i].PureWt=parseFloat((val(DetTable[i].NetWt)+val(DetTable[i].Wasteage))*val(DetTable[i].Touch)/100).toFixed(2);
    }  
}
setDtDetTable(DetTable);

setlocaltime(new Date());


}


async function ControlSettings()
{

  document.getElementById("txtIssueNo").disabled ='true';
  document.getElementById("txtIssueDate").disabled ='true';
  
  if((sessionStorage.getItem("OrnamentIssue_Action")=="Edit") || (sessionStorage.getItem("OrnamentIssue_Action")=="Delete"))
   {
  

    document.getElementById("optSmith").disabled ='true';
    document.getElementById("optDealer").disabled ='true';
    
    document.getElementById("optGold").disabled ='true';
    document.getElementById("optSilver").disabled ='true';
    
    document.getElementById("txtPartyName").disabled ='true';
    document.getElementById("txtGrnNo").disabled ='true';
   

   }

 



}

async function Display(EditId){
	  try
    {
     
      let postData = {
        EditId: EditId
    }


  

    const results = await apiService.postCall("ornamentissue/Display",postData);


   if (results != "-1") {
     
	 let HeadData=results.data.Head;
   let DetailData=results.data.Detail;

  if(HeadData[0][0].OrderType=="SMITH")
  {
    document.getElementById("optSmith").checked=true;
  }
  else if(HeadData[0][0].OrderType=="DEALER")
  {
    document.getElementById("optDealer").checked=true;
  }
  


  if(HeadData[0][0].MetalType=="GOLD")
  {
    document.getElementById("optGold").checked=true;
  }
  else if(HeadData[0][0].MetalType=="SILVER")
  {
    document.getElementById("optSilver").checked=true;
  }
  

  await getLookup();
  


   document.getElementById("txtIssueNo").value =HeadData[0][0].IssueNo;
   document.getElementById("txtIssueDate").value=HeadData[0][0].IssueDate.substring(0,10);
   setAccCode(HeadData[0][0].AccCode);
   setGrnNo(HeadData[0][0].GrnNo);
   document.getElementById("txtRemarks").value=HeadData[0][0].Remarks;

  
   DetTable=DetailData[0];

   await setDtDetTable(DetTable);


   }

    
    }
    catch (error) {
      console.log(error);
    }

  }


async function Save(){
	  try
		{
	
if (DtDetTable.length==0)
{
	swal({

      title: "",
      text: "Please Enter Details",
      icon: "info",
      button: "Ok"

    });
	
	return;
}	
			
			
			
		const optary = document.getElementsByName("group_partytype");
		 let optpartytype="";
		 let i;
		 
		 for(i=0;i<optary.length;i++)
		 {
			 if(optary[i].checked==true)
			 {
				  optpartytype=optary[i].value;
			 }
		 }
		 
		 
	const optary1 = document.getElementsByName("group_metaltype");
     let optmetaltype="";
    
     for(i=0;i<optary1.length;i++)
     {
       if(optary1[i].checked==true)
       {
          optmetaltype=optary1[i].value;
       }
     }
		 
		let postData = {
			"Action" : sessionStorage.getItem("OrnamentIssue_Action"),
			"EditId" : sessionStorage.getItem("OrnamentIssue_EditId"),
      "eBranchCode" : sessionStorage.getItem("BranchCode"),
			"FinMinDate":sessionStorage.getItem("FinMinDate").substring(0,10),
			"FinMaxDate":sessionStorage.getItem("FinMaxDate").substring(0,10),
			"EntryUser":sessionStorage.getItem("EntryUser"),
			"IssueDate": document.getElementById("txtIssueDate").value,
			"AccCode": AccCodeRef.current,
			"PartyType": optpartytype,
			"MetalType": optmetaltype,
			"GrnNo": GrnNoRef.current,
			"Remarks": document.getElementById("txtRemarks").value,
			"DetTable1": DtDetTable
     
		}

    

   const results = await apiService.postCall("ornamentissue/Save",postData);


  

   if (results != "-1") {

if(results.errorCode=="8888")
{


  swal({

    title: "Alert",
    text: results.data,
    icon: "info",
    button: "Ok"
    
  }).then(function () {
    
  });

  return;

}  
  if(sessionStorage.getItem("OrnamentIssue_Action")=="Add")
   {
    swal({

      title: "Success",
      text: "Successfully Add Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }

  else if(sessionStorage.getItem("OrnamentIssue_Action")=="Edit")
   {
    swal({

      title: "Success",
      text: "Successfully Update Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }
	 
  else if(sessionStorage.getItem("OrnamentIssue_Action")=="Delete")
  {
   swal({

     title: "Success",
     text: "Successfully Delete Your Details!",
     icon: "success",
     button: "Ok"

   }).then(function () {
    BackToList();
   });
 
 }
	 
      }
    }
    catch (error) {
      console.log(error);
    }

  }






  async function getLookup(){
	 try {
		
    let postData=[];


    const results = await apiService.postCall("ornamentissue/Lookup",postData);

	 if (results != "-1") {

    

			setDtParty(results.data[0][0]);
      setDtGrnNo(results.data[1][0]);
   
    

      }



    } catch (error) {
      console.log(error);
    }
}


async function GetGrnDetail(){
  try {
   
    

   let postData={
    GrnNo: GrnNoRef.current
   };

   const results = await apiService.postCall("ornamentissue/getgrndetail",postData);

  if (results != "-1") {
    setDtDetTable(results.data[0][0]);   
     }



   } catch (error) {
     console.log(error);
   }
}

 
  const navigate = useNavigate();
  const BackToList = () => {
    navigate('../dashboard/table/smith/ornamentissue/list');
  };

  return (
    <>
    <input type="Hidden" id="txtId" />
    
      <Row>
        <Card>
          <Card.Header className="d-flex justify-content-between">
            <div className="header-title">
              <h4 className="card-title">Ornament Issue Screen</h4>
            </div>
          </Card.Header>
          <Card.Body>
            <div className='container'>
              <div className='container-fluid'>
                <div className='row'>
                  <div className='col-lg-6'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='d-flex flex-row justify-content-around'>
                        <div >
                          <Form.Check.Input id="optGold" value="GOLD"  name="group_metaltype" type="radio" className='me-2' />
                          <Form.Check.Label>GOLD</Form.Check.Label>
                        </div>
                        <div >
                          <Form.Check.Input value="SILVER" id="optSilver" name="group_metaltype" type="radio" className='me-2' />
                          <Form.Check.Label>SILVER</Form.Check.Label>
                        </div>
                        
                      </div>
                      <div className='container-fluid py-4 '>
                        <div className='row py-2'>
                          <div className='col-md-6'>
                            <Form.Label>Grn No</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" id="txtIssueNo" placeholder="" />
                          </div>
						  
						  
						  <div className='col-md-6'>
                            <Form.Label>Date</Form.Label>
                            <Form.Control type="date" Readonly="Readonly" id="txtIssueDate" placeholder="" />
                          </div>
						  
						  
                          <div className='col-md-12'>
                            <Form.Label>Party Name</Form.Label>

                            <Select className="" id="txtPartyName" 
                             options={DtParty}
                             isDisabled={isDisabled}
                             value={DtParty.filter(function(option) {
                              return option.value === AccCode;
                            })}
                            onChange=
                            {
                              (e) => {

                                 setAccCode(e.value);
                                
                              }
                              }
                             >
              								
							               </Select>

                       
                          </div>



                        </div>
                        
                        
                      </div>

                    </div>

                  </div>
                  <div className='col-lg-6'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='d-flex flex-row justify-content-around'>
                        <div >
                          <Form.Check.Input value="SMITH" id="optSmith" name="group_partytype" type="radio" className='me-2' />
                          <Form.Check.Label>SMITH</Form.Check.Label>
                        </div>
                        <div >
                          <Form.Check.Input value="DEALER"  id="optDealer"  name="group_partytype" type="radio" className='me-2'  />
                          <Form.Check.Label>DEALER</Form.Check.Label>
                        </div>
                        
                      </div>
                      <div className='container-fluid py-4 '>
                        <div className='row '>
                          <div className='row py-2'>
                            <div className='col-md-6'>
                              <Form.Label>Grn No</Form.Label>

                            <Select className="" id="txtGrnNo" 
                             options={DtGrnNo}
                             isDisabled={isDisabled}
                             value={DtGrnNo.filter(function(option) {
                              return option.value === GrnNo;
                            })}
                            onChange=
                            {
                              (e) => {

                                 setGrnNo(e.value);
                                 GetGrnDetail();
                              }
                              }
                             >
              								
							               </Select>

                            
                            </div>
                            
                          </div>
                          <div className='col-md-12 py-2'>
                            <Form.Label>Remark</Form.Label>
                            <Form.Control type="text" id="txtRemarks" placeholder="" />
                          </div>

                        
                        </div>
                      </div>
                    </div>
                  </div>

                 
                 
                                              
                </div>
              </div>
			  
			  
			    
				
          
				
				
	

                  
              <div className="table-responsive mt-4" >
			 
				
                <Table striped id="basic-table" className="table-striped mb-0" role="grid">
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th>Sub Product</th>
                      <th>Purity</th>   
                      <th>Pcs</th>              
                      <th>Gross Wt</th>
                      <th>Less Wt</th>
                      <th>Net Wt</th>
                      <th>Waste %</th>
                      <th>Wasteage</th>
                      <th>MC Value</th>
                      <th>Touch</th>  
                      <th>Pure Wt</th>  
                      <th>St.Amt</th>  
                      <th>O.Amt</th>  
                      <th>HM</th>  
                      
						<th>Delete</th>					  
                    </tr>
                  </thead>
                  <tbody>
                  {DtDetTable.map((item) => (
                    <tr>
                      
                      <td>{item.ProdName}</td>
                      <td>{item.SubProdName}</td>
                      <td>{item.Purity}</td>
                      <td><Form.Control type="text" value={item.Pcs} id={'Pcs' + item.ID} onChange={(e)=>SetGridValue(item.ID,e.target.value,'Pcs')}  className='me-2 gridbox'  /></td>
                      <td><Form.Control type="text" value={item.GrossWt} id={'GrossWt' + item.ID} onChange={
                        (e)=>SetGridValue(item.ID,e.target.value,'GrossWt')}  className='me-2'  /></td>
                      <td><Form.Control type="text" value={item.LessWt} id={'LessWt' + item.ID} onChange={(e)=>SetGridValue(item.ID,e.target.value,'LessWt')}  className='me-2 gridbox'  /></td>
                      <td>{item.NetWt}</td> 
                      <td><Form.Control type="text" value={item.WasteP} id={'WasteP' + item.ID} onChange={(e)=>SetGridValue(item.ID,e.target.value,'WasteP')}  className='me-2 gridbox'  /></td>
                    <td>{item.Wasteage}</td>  
                      <td>{item.MCValue}</td>  
                      <td><Form.Control type="text" value={item.Touch} id={'Touch' + item.ID} onChange={(e)=>SetGridValue(item.ID,e.target.value,'Touch')}  className='me-2 gridbox'  /></td>  
                      <td>{item.PureWt}</td>    
                      <td>{item.StoneAmt}</td>    
                      <td>{item.OtherCharges}</td>    
                      <td>{item.HallMark}</td>    
                       
		
		<td>
					 <Link className="btn btn-sm btn-icon text-danger" data-bs-toggle="tooltip" title="Delete" to="#" onClick={(e)=>gridRemove(item.ID)}>
                            <span className="btn-inner">
                              <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                                <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>
                            </span>
                          </Link>
					</td>
                    </tr>
                      )
                      )
                       }     
                  </tbody>
                </Table>
				
              </div>
              <div className='pt-2' style={{ direction: 'rtl' }} >
                <Form.Group className="form-group">
                  <Button type="button" variant='btn btn-primary'  onClick={TagPrint} >
                    <i className="btn-inner">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
                      </svg>
                    </i>
                    <span>Print</span>
                  </Button>{' '}
                  <Button type="button" variant="btn btn-danger" onClick={BackToList}>cancel</Button> {' '}
                  <Button type="button" variant="btn btn-primary"  disabled={btndisabled} onClick={Save}>{SaveButtonText}</Button>
                </Form.Group>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Row >
    </>
  );
};

export default TableData;
